import React, { useCallback, useMemo } from 'react';
import { useField, useForm } from 'react-final-form';
import { observer } from 'mobx-react';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';
import { sortBy } from 'lodash-es';

import { reportSettingEditStore } from '@stores/dictionaryStores/reportSettings/reportSettingEditStore';
import { reportSettingsStore } from '@stores/dictionaryStores/reportSettings/reportSettingsStore';
import { reportVersionsStore } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';
import type { ReportSettingLevelDtoDefId } from '@stores/dictionaryStores/reportSettings/reportSettingsStore';

export const UrlParamFields = observer(() => {
  const { isEditMode } = reportSettingEditStore;
  const { reportSettingsLevel } = reportSettingsStore;
  const { reportVersions } = reportVersionsStore;
  const { change } = useForm();

  const {
    input: { onChange: changeRoundedValue },
  } = useField('rounded');

  const {
    input: { onChange: changeIsDeltaApproach },
  } = useField('isDeltaApproach');

  const {
    input: { value: reportVersionCodeValue },
  } = useField('reportVersionCode');

  const {
    input: { onChange: changeNewWindow },
  } = useField('newWindow');

  const levelItems = useMemo(() => {
    const group = reportVersions?.find((item) => item.code === reportVersionCodeValue)?.reportGroupCode;

    const out = reportSettingsLevel
      .filter((item) => {
        if (item.level === 'level4') return group === 'D01' ? item.groupLevel === 'D01' : !item.groupLevel;
        return item;
      })
      .map((item) => ({
        id: item.id,
        name: `${item.level} - ${item.reportTypeLevel}`,
        level: Number(item.level?.split('level')[1]),
      }));

    return sortBy(out, 'level');
  }, [reportSettingsLevel, reportVersionCodeValue, reportVersions]);

  const onChange = useCallback(
    (value) => {
      const selectLevel = reportSettingsLevel.find((item) => item.id === value);

      if (selectLevel) {
        ['urlP1', 'urlP2', 'urlP3', 'urlP4', 'urlP5', 'urlP6', 'urlP7', 'urlP8', 'urlP9', 'urlP10'].forEach((item) =>
          change(item, selectLevel[item as keyof ReportSettingLevelDtoDefId]),
        );

        if (selectLevel.level !== 'level1' && selectLevel.level !== 'level2') {
          changeRoundedValue(false);
        }

        if (selectLevel.level !== 'level3') {
          changeIsDeltaApproach(false);
        }

        if (selectLevel.level !== 'level1') {
          changeNewWindow(false);
        }
      }
    },
    [change, changeIsDeltaApproach, changeNewWindow, changeRoundedValue, reportSettingsLevel],
  );

  return (
    <>
      <SelectField
        name="levelId"
        items={levelItems}
        onChange={onChange}
        label="Тип отчета"
        size="small"
        groupStyle
        maxLength={500}
        disabled={!isEditMode}
      />
    </>
  );
});
